import React from 'react';
import { useSelector } from 'react-redux';
import SetupCard from './SetupCard';
import TextCenter from '../Typography/TextCenter';
import Header from '../Typography/Header';
import Subheader from '../Typography/Subheader';
import RealGrid from '../Layout/RealGrid';
import IntlMessages from 'util/IntlMessages';

const industries = [
  {
    id: 'clothing',
    title: "ui.setupRecs.setupRecsIndustry.clothingApparelFashion",
    icon: 'clothing.svg',
  },
  {
    id: 'shoes',
    title: "ui.setupRecs.setupRecsIndustry.shoesAccessories",
    icon: 'accessories.svg',
  },
  {
    id: 'electronics',
    title: "ui.setupRecs.setupRecsIndustry.electronicsAndCellPhones",
    icon: 'electronics.svg',
  },
  {
    id: 'interior',
    title: "ui.setupRecs.setupRecsIndustry.furnitureArtDesign",
    icon: 'interior.svg',
  },
  {
    id: 'diy',
    title: "ui.setupRecs.setupRecsIndustry.toolsAutomotiveAndDiy",
    icon: 'diy.svg',
  },
  {
    id: 'kids',
    title: "ui.setupRecs.setupRecsIndustry.kidsClothingAccessoriesToys",
    icon: 'kids.svg',
  },
  {
    id: 'sport',
    title: "ui.setupRecs.setupRecsIndustry.sportAndEquipment",
    icon: 'sport.svg',
  },
  {
    id: 'exterior',
    title: "ui.setupRecs.setupRecsIndustry.homeGarden",
    icon: 'exterior.svg',
  },
  {
    id: 'pets',
    title: "ui.setupRecs.setupRecsIndustry.pets",
    icon: 'pets.svg',
  },
  {
    id: 'books',
    title: "ui.setupRecs.setupRecsIndustry.booksMusicAndFilms",
    icon: 'books.svg',
  },
  {
    id: 'food',
    title: "ui.setupRecs.setupRecsIndustry.foodBeverages",
    icon: 'food.svg',
  },
  {
    id: 'other',
    title: "ui.setupRecs.setupRecsIndustry.other",
    icon: 'other.svg',
  },
];

export default function SetupRecsIndustry({ onClick }) {
  const activeCards = useSelector((store) => store.onboarding.recs.industries);
  const cards = industries.map((industry) => {
    const { id, title, icon } = industry;
    const active = activeCards.indexOf(id) > -1;
    return (
      <SetupCard
        active={active}
        key={id}
        title={title}
        icon={icon}
        onClick={() => onClick(id)}
      />
    );
  });

  return (
    <TextCenter>
      <Header variant="2"><IntlMessages id="ui.setupRecs.setupRecsIndustry.whatIsYourIndustry" /></Header>
      <Subheader><IntlMessages id="ui.setupRecs.setupRecsIndustry.pleaseSelectIndustriesWhichApplyToYourBusinessYouCan" /></Subheader>
      <RealGrid>{cards}</RealGrid>
    </TextCenter>
  );
}
